import { createStore } from 'vuex';

import commonStore from '@/common/store';
import projectStore from '@/views/Projects/store';
import authStore from '@/store/modules/auth';

const store = createStore({
  modules: {
    common: commonStore,
    project: projectStore,
    auth: authStore,
  },
});

export default store;